module.exports = __webpack_public_path__ + "9640c96c23086fbb144609eba2af261a.svg";